'use strict';

var assign = require('lodash/assign');
var extend = require('lodash/extend');
var filter = require('lodash/filter');
var find = require('lodash/find');
var forEach = require('lodash/forEach');
var groupBy = require('lodash/groupBy');
var kebabCase = require('lodash/kebabCase');
var map = require('lodash/map');
var reduce = require('lodash/reduce');
var sortBy = require('lodash/sortBy');
var intersection = require('lodash/intersection');
var isArray = require('lodash/isArray');

module.exports = [function () {

    var FACET_CONFIG;

    var facetUIData = [];

    var initialKeywords = null;

    var ageSorter = {
        'newborn-5 years': 0,
        '0-5': 0,
        '0-5 years': 0,
        '6-12 years': 1,
        '6-12': 1,
        'teens': 2,
        'adults': 3,
        'seniors': 4,
        'multigenerational': 5
    };

    function init(facetconfig) {
        facetconfig.forEach(function (facet, index) {
            var item = extend({
                keywordCondition: false,
                toggle: true,
                visible: true,
                open: false
            }, facet);

            if (item.keywordCondition && !isArray(item.keywordCondition)) {
                item.keywordCondition = [item.keywordCondition];
            }

            facetconfig[index] = item;
        });

        FACET_CONFIG = facetconfig;
    }

    var shortTitleFor = [];

    function buildFacetGroups(events) {
        var facetCategories = map(FACET_CONFIG, 'category');

        var keywords = events.reduce(function(acc, event) {
            var allKeywords = event.CategoryProductionKeywords;
            acc = acc.concat(allKeywords.filter(function(item) {
                return (
                    item.keyword !== 'Class' &&
                    facetCategories.indexOf(item.category) !== -1
                );
            }));
            return acc;
        }, []);

        var facetsGroups = map(groupKeywords(keywords), function(items, groupKey) {
            var matchingConfig = find(FACET_CONFIG, function(x) {
                return x.category === groupKey;
            });

            var facets = groupBy(items, function(x) {
                return x.keyword;
            });

            facets = map(facets, function(xs, key) {
                return {
                    title: shortTitleFor.indexOf(groupKey) !== -1 ? key.substring(0, 3) : key,
                    keyword: key,
                    slug: kebabCase(key),
                    category: groupKey,
                    count: xs.length,
                    disabled: false,
                    selected: false
                };
            });

            if (groupKey === '10a_dd_Age Levels') {
                facets = facets.sort(function (a, b) {
                    var day1 = a.keyword.toLowerCase();
                    var day2 = b.keyword.toLowerCase();

                    return ageSorter[day1] > ageSorter[day2];
                });
            } else {
                facets = sortBy(facets, function(x) {
                    return x.keyword;
                });
            }

            return assign(matchingConfig, {facets:facets});

        });

        var facetsGroupsOrderedByConfig = reduce(FACET_CONFIG, function(groupArray, facetGroup){
            var group = find(facetsGroups, function(group){
                return group.category === facetGroup.category;
            });
            if (group) {
                groupArray.push(group);
            }
            return groupArray;
        },[]);

        facetUIData = facetsGroupsOrderedByConfig;
        return facetUIData;
    }

    function groupKeywords(keywords) {
        return groupBy(keywords, function(item) {
            return item.category;
        });
    }

    function updateFacetUI(selectedFacets, events){

        var selectedFacetsMap = map(selectedFacets, 'category');
        var selectedFacetsKeywords = map(selectedFacets, function (facet) {
            return facet.category + '|' + facet.keyword;
        });
        var eventByType = groupKeywords(extractKeywords(events));

        var reducedFacetUI = reduce(facetUIData, function(arr, facetGroup){
            if (selectedFacetsMap.indexOf(facetGroup.category) === -1 ) { // the facetGroup has not been selected
                var groupedTypes = groupBy(eventByType[facetGroup.category], 'keyword');
                forEach(facetGroup.facets, function(facet){
                    if (groupedTypes[facet.keyword]) {
                        facet.count = groupedTypes[facet.keyword].length;
                        facet.disabled = false;
                    }else{
                        facet.count = 0;
                        facet.disabled = true;
                    }
                });
            }

            arr.push(facetGroup);
            return arr;
        }, []);

        reducedFacetUI = reducedFacetUI.reduce(function (arr, group) {
            var selected = false;

            group.facets.forEach(function (facet) {
                var key = facet.category + '|' + facet.keyword;

                facet.selected = selectedFacetsKeywords.indexOf(key) !== -1;

                if (!selected && facet.selected) {
                    selected = true;
                }
            });

            if (group.keywordCondition !== false) {
                var matches = intersection(selectedFacetsKeywords, group.keywordCondition);

                if (matches.length) {
                    group.visible = true;
                    group.open = true;
                } else {
                    group.visible = false;
                }
            }

            if (group.keywordCondition === false && selected) {
                group.open = true;
            }

            arr.push(group);

            return arr;
        }, []);

        facetUIData = reducedFacetUI;
    }

    function extractKeywords(events) {
        var facetCategories = FACET_CONFIG.map(function(item) { return item.category; });
        var keywords = events.reduce(function(acc, event) {
            var allKeywords = event.CategoryProductionKeywords;
            acc = acc.concat(allKeywords.filter(function(item) {
                return (
                    item.keyword !== 'Class' &&
                    facetCategories.indexOf(item.category) !== -1
                );
            }));
            return acc;
        }, []);

        if (initialKeywords === null) {
            initialKeywords = keywords;
        }

        return sortBy(keywords, function(item) {
            return facetCategories.indexOf(item.category);
        });
    }

    function getChildFacets(facetsToClear) {
        var facets = map(facetsToClear, function (facet) {
            return facet.category + '|' + facet.keyword;
        });
        return filter(facetUIData, function(facetGroup){
            return intersection(facets, facetGroup.keywordCondition).length;
        });
    }

    return {
        init: init,
        buildFacetGroups: buildFacetGroups,
        updateFacetUI: updateFacetUI,
        facetUIData: facetUIData,
        extractKeywords: extractKeywords,
        groupKeywords: groupKeywords,
        getChildFacets: getChildFacets
    };
}];



// WEBPACK FOOTER //
// ./widgets/services/FTFServices/FacetManager.js